import React, { PropsWithoutRef, type JSX } from 'react';

import { Grid2, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type ModelHeaderProps = {
  title: string | JSX.Element;
  handleClose: () => void;
};

const DefaultModelHeader = ({
  title,
  handleClose,
}: PropsWithoutRef<ModelHeaderProps>) => (
  <Grid2 container>
    <Grid2 sx={{ display: 'flex', alignItems: 'center' }} size="grow">
      {typeof title === 'string' ? (
        <Typography variant="h6">{title}</Typography>
      ) : (
        title
      )}
    </Grid2>
    <Grid2>
      <IconButton onClick={handleClose}>
        <CloseIcon />
      </IconButton>
    </Grid2>
  </Grid2>
);

export default DefaultModelHeader;
